import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    formInput: {
      padding: '0px',
      margin: '10px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      appearance: 'none',
    },
    middleText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '18px',
      color: '#2C2D3E',
      margin: '70px 0px 20px 0px'
    },
    numberCircleInline: {
      marginRight: '9px',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      background: '#3C419A',
      color: '#FFFFFF',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesInline: {
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      display: 'inline-block',
    },
    numberCircleOutlineCheck: {
      position: 'relative',
      marginRight: '9px',
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      border: '1px solid #3C419A',
      background: '#FFFFF',
      color: '#3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesOutlineCheck: {
      position: 'relative',
      top: '4px',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      display: 'inline-block',
    },
    numberCircleOutline: {
      position: 'relative',
      marginRight: '9px',
      marginTop: '3px',
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      border: '1px solid #3C419A',
      background: '#FFFFF',
      color: '#3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesOutline: {
      position: 'relative',
      top: '3px',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      display: 'inline-block',
    },
    numberCircleOutlineFirst: {
      marginLeft: '24px',
      position: 'relative',
      marginRight: '9px',
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      border: '1px solid #3C419A',
      background: '#FFFFF',
      color: '#3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesOutlineFirst: {
      position: 'relative',
      top: '2px',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      display: 'inline-block',
    },
    textOutline: {
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      '& p': {
        margin: '0',
      },
    },
    line: {
      margin: '20px',
      width: '70px',
      height: '0px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.4,
      display: 'flex',
      align: 'center',
    },
    textInline: {
      marginLeft: '10px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      fontWeight: 'bold',
    },
    menuItem: {
      '&:hover': {
        backgroundColor: '#CACAFC33',
        color: '#3C419A',
      },
    },
    checkOutline: {
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      background: '#FFFFFF',
      color: '#3C419A',
      border: '1px solid #3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    checkOutlineInside: {
      position: 'relative',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      top: '2px',
      display: 'inline-block',
    },
    centeredContainer: {
      textAlign: 'center',
      padding: '60px 200px',
      marginBottom: '90px'
    },
    paddedItem: {
      padding: '13px 10px',
    },
  }),
);
